import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-573d2ed3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language" }
const _hoisted_2 = { class: "language__items" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "selected-tick",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "language__actions" }

import { dismissCurrentModal } from '@/helpers/modal'
import { notifySuccess } from '@/helpers/notification'
import { Languages } from '@/models/enums/Languages'
import customerService from '@/services/customer-service'
import { useCustomerStore } from '@/state/customer'
import { Customers } from 'package-types'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import VBtn from '../shared/VBtn.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageModal',
  setup(__props) {

const { customer, setCustomer } = useCustomerStore()
const { t, locale } = useI18n()

const selectedLanguage = ref('')

onMounted(() => {
  selectedLanguage.value = customer?.lang as string
})

const closeModal = () => {
  dismissCurrentModal()
}

const onConfirm = async () => {
  const { customer } = await customerService.updateCustomer({
    lang: selectedLanguage.value
  } as Partial<Customers.Actions.UpdateCustomerArguments>)

  setCustomer(customer)
  locale.value = customer?.lang as string
  await notifySuccess(t('account.lang_change'))
  closeModal()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(Languages)), (lang, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["language__name", { active: selectedLanguage.value === lang }]),
          onClick: ($event: any) => (selectedLanguage.value = lang)
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t(`account.languages.${lang}`)) + " ", 1),
          (selectedLanguage.value === lang)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(VBtn, {
        light: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.back')), 1)
        ]),
        _: 1
      }),
      _createVNode(VBtn, {
        green: "",
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})